module.exports = __webpack_public_path__ + "bfe04987019fa0416f74a2a456cd940a.MP3";